import { render, staticRenderFns } from "./DigitalDocShortList.vue?vue&type=template&id=25f0d62c&scoped=true"
import script from "./DigitalDocShortList.vue?vue&type=script&lang=js"
export * from "./DigitalDocShortList.vue?vue&type=script&lang=js"
import style0 from "./DigitalDocShortList.vue?vue&type=style&index=0&id=25f0d62c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25f0d62c",
  null
  
)

export default component.exports